import React from 'react';

// Icons
import { FaTwitter } from 'react-icons/fa';
import { FaBluesky } from 'react-icons/fa6';
import { FaDiscord, FaEnvelope } from 'react-icons/fa';

// Constants
import {
  LOYALFANS_URL,
  TWITTER_URL,
  BLUESKY_URL,
  FETLIFE_URL,
  DISCORD_URL,
  CompanyEmailAddress,
} from '../constants/Constants';

// Images
import LoyalFansIcon from '../../assets/images/icons/loyalfans-icon-no-background.png';
import FetlifeIcon from '../../assets/images/icons/fetfile-icon-no-background.png';

export const contactPagePinsArray = [
  {
    name: 'LoyalFans',
    url: LOYALFANS_URL,
    icon: LoyalFansIcon,
  },
  {
    name: 'Email',
    url: `mailto:${CompanyEmailAddress}`,
    icon: <FaEnvelope className='text-6xl' />,
  },
  {
    name: 'Discord',
    url: DISCORD_URL,
    icon: <FaDiscord className='text-6xl' />,
  },
  {
    name: 'Twitter',
    url: TWITTER_URL,
    icon: <FaTwitter className='text-6xl' />,
  },
  {
    name: 'BlueSky',
    url: BLUESKY_URL,
    icon: <FaBluesky className='text-6xl' />,
  },
  {
    name: 'Fetlife',
    url: FETLIFE_URL,
    icon: FetlifeIcon,
  },
];
